/* eslint-disable camelcase */
import { State } from "@hookstate/core";
import { LatLng } from 'leaflet';
import useEntryState from "../stores/EntryState";

interface entrySocketProps {
  readonly message: any;
  readonly translate?: any;
  readonly handleUpdateMyEntries?: any;
  readonly socketUpdateEntry?: any;
  readonly entry?: any;
  readonly actualNotification: () => State<number|null>;
  readonly getEntryFromId?: any;
  readonly createMarker?: any;
  readonly forceViewMap?: any;
}

export default function entriesSocket({ message, translate, handleUpdateMyEntries, socketUpdateEntry, entry, actualNotification, getEntryFromId, createMarker, forceViewMap }: entrySocketProps) {
  console.info(`Dispatch socket received: ${message.event_type}`);

  if (message.event_type === 'ENTRY_CREATED') {
    try {
      const { id, from_telephony_integration, latitude, longitude, location, type_name: typeName, subtype_name: subtypeName } = message.content;
      
      if (from_telephony_integration === true && getEntryFromId) {
        getEntryFromId(id).then(() => {
          if (latitude && longitude && createMarker && forceViewMap) {
            const position = new LatLng(Number(latitude), Number(longitude));

            createMarker({
              markerType: 'entry',
              markerIdentifier: id,
              id,
              isCurrent: true,
              position: position,
              location: location ?? null,
              typeName: typeName ?? null,
              subtypeName: subtypeName ?? null,
              status: 1,
            });

            forceViewMap().zoom.set(17);
            forceViewMap().position.set(position);
          }
        });
      }
    } catch (error) {
      console.log(error);
      console.error(`Erro ao processar ENTRY_CREATED: ${JSON.stringify(message)} - ${JSON.stringify(error)}`);
    }
  }

  if (message.event_type === 'ENTRY_UPDATED') {
    try {
      const {
        address,
        address_reference: addressReference,
        created_at: createdAt,
        entry_origin_id: entryOriginId,
        id: id,
        latitude,
        longitude,
        location,
        name,
        phone,
        subtype_id: subtypeId,
        subtypename,
        type_id: typeId,
        typename,
        updated_at: updatedAt
      } = message.content

      socketUpdateEntry({
        entry: {
          address,
          addressReference,
          createdAt,
          entryOriginId,
          id,
          latitude,
          longitude,
          location,
          name,
          phone,
          subtypeId,
          subtypename,
          typeId,
          typename,
          updatedAt
        },
      })
    } catch (error) {
      console.log(error);
      console.error(`Erro  ${JSON.stringify(message)} - ${JSON.stringify(error)}`);
    }

  }

}